import React from 'react'
import LenderUgroService from '../../../services/lender';
import { toast } from 'react-toastify';
import { downloadFile } from '../../../common/download';
import { useRouter } from '../../../hooks/useRouter';

const DownloadFileData = ({ row }) => {

    const params = useRouter()
    const fileType = params?.pathname?.split('/')?.[2];
    const lenderId = params?.pathname?.split('/')?.[3];

    const downloadBulkUploadFile = async (fileId, fileName) => {
        try {
            const response = await LenderUgroService.downloadAddInfoFile({
                fileId,
                fileType,
                responseType: 'blob',
                lenderId
            });
            downloadFile(response?.data, fileName)
        } catch (err) {
            toast(
                err.response?.data?.messages?.error?.file?.[0] ||
                err.response?.data?.messages?.error?.form?.[0] ||
                err.response?.data?.messages?.error?.others?.[0]
            )
        }
    }

    return (
        row?.file_json ?
        <div style={{ cursor: 'pointer' }} onClick={() => downloadBulkUploadFile(row?.fundout_file_id, row?.name)}>
            <span>{row?.name}</span>
            <span className='ml-3' style={{ cursor: 'pointer' , color: '#0ba6ff' }}><i class="fa fa-download" aria-hidden="true"></i></span>
        </div>
        :
        <div>
            <span>{row?.name}</span>
        </div>
    )
}

export default DownloadFileData